<script setup lang="ts">
import { OptionMain } from '~/lib/services/store/catalog/catalog.dtos'

const props = defineProps<{
  option: OptionMain
  countRow: number
  disableAdd: boolean
}>()

defineEmits(['update:countRow'])
const { format } = useFormatAmount()

const countRowState = useVModel(props, 'countRow')

const priceAmount = props.option.price?.amount || 0

const isDiffering = computed(() => {
  if (!priceAmount) return false
  return countRowState.value > props.option.initialQty
})
const differingQuantity: ComputedRef<number> = computed(() =>
  !isDiffering.value ? 0 : countRowState.value - props.option.initialQty
)
const differingAmount = computed(() => {
  if (!isDiffering) return 0
  return format(differingQuantity.value * priceAmount)
})
</script>
<template>
  <div data-test="quantity-selector-row" class="my-4 flex flex-row items-center gap-2">
    <div class="relative h-12 w-12 min-w-[3rem] rounded-[50%] bg-mcd-secondary">
      <ImageResolver
        class="absolute left-1/2 top-1/2 h-9 w-auto -translate-x-1/2 -translate-y-1/2"
        :url="option.imageUrl"
        :alt="option.name"
      />
    </div>
    <p class="line-clamp-2 flex-1 text-sm font-bold">
      {{ option.name }}
    </p>
    <div
      data-test="quantity-selector-row__price"
      class="flex min-w-[60px] flex-row items-center justify-center gap-1"
    >
      <template v-if="isDiffering">
        <span class="text-sm text-mcd-secondaryDarkGrey">+{{ differingQuantity }}</span>
        <span class="text-sm font-bold">{{ differingAmount }}</span>
      </template>
    </div>
    <QuantitySelector
      v-model:count="countRowState"
      :min="option.min"
      :max="option.max"
      :show-delete="false"
      :disable-add="disableAdd"
    />
  </div>
</template>
